import React, {Component} from 'react';
import _ from 'lodash';
import InfiniteScroll from 'react-infinite-scroller';

/*
 @method: loadItems send page number
 @props: page int
 @props: hasMoreItems boolean
 @props: content/children tbody array
 @props: header  thead array
 */
export default class ScrollLoad extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: props.children
    };
  }
  shouldComponentUpdate(nextProps, nextState){

    return this.props.page !== nextProps.page;

  }
  componentWillReceiveProps(nextProps) {
    let {page, children, hasMoreItems} = nextProps,
      {items} = this.state;
    //page > this.props.page
    if (page > 0) {
      items.push(...children);
    } else {
      items = children;
    }
    this.setState({
      items
    });

  }

  render() {
    //console.log(this);
    const loader = <div className="loader">Загрузка ...</div>,
      {page, loadItems, hasMoreItems, className, header} = this.props;

    return (
      <table className={className}>
        {header}
        {this.state.items.length > 0 ? <InfiniteScroll
          pageStart={0}
          initialLoad={true}
          element="tbody"
          loadMore={loadItems}
          hasMore={hasMoreItems}
          loader={loader}>

          {this.state.items}
        </InfiniteScroll> : ''}
      </table>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/ScrollLoad.jsx
 **/